<template>
    <div class="animated fadeIn">
      <b-modal
        :id="modalId"
      >
        <p class="my-4">Should we send thank you email to member?</p>
        <template v-slot:modal-footer="{yes, no}">
          <b-button size="sm" variant="success" @click="handleModal(true)">
            Yes
          </b-button>
          <b-button size="sm" variant="danger" @click="handleModal(false)">
            No
          </b-button>
        </template>
      </b-modal>
    </div>
</template>
<script>
    export default {
        name: 'membership-send-mail-modal',
        data() {
            return {
                modalId: 'sendMailModal'
            }
        },
        methods: {
            handleModal(result) {
                this.$emit('click', result)
                this.$root.$bvModal.hide(this.modalId)
            },
        }
    }
</script>
